export default __webpack_public_path__ + "assets/images/2aa9d50bbd22c9f3b8181d2ab4043872.png";